export const mediaPhone = (css) => {
  return `
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
      ${css}
    }
  `;
};

export default mediaPhone;



// WEBPACK FOOTER //
// ./src/styles/utils.js